/* @flow */
import moment from "moment";
import type { Action } from "../action";
import type { SocialTrading } from "../CommonTypes";

type State = Array<SocialTrading>;

// {
//   type: "RECEIVE_SOCKET_MESSAGE",
//   payload: {
//     op: "social_trading",
//     id: 192993939,
//     stock: "EURUSD",
//     user_id: "1***99",
//     isBidUp: true,
//     profit: 900
//   }
// }

function receiveSocketMessage(state: State, payload) {
  switch (payload.op) {
    case "social_trading":
      const timestamp = moment().valueOf();

      const updatedState = [
        {
          ...payload,
          timestamp
        },
        ...state
      ];

      if (updatedState.length > 30) {
        updatedState.length = 30;
      }

      return updatedState;
    default:
      return state;
  }
}

function socialTrading(state?: State = [], action: Action): State {
  switch (action.type) {
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    default:
      return state;
  }
}

export default socialTrading;



// WEBPACK FOOTER //
// ./src/redux/reducer/socialTrading.js